<template>

    <div v-if="!loading && links.length > 0" style="display: contents;">
        <div class="crmCaption">
            {{ttl.SimilarTopics}}
        </div>
        <div class="echBox">
            <div class="nodes" v-for="node in nodes" :key="node.key" @click="openDetail(node.key)">
                <span class="nodeTitle">
                    <span> {{node.key}} </span> <span>{{node.name}}</span>
                </span>
            </div>

        </div>
    </div>
</template>

<script>
    //https://codesandbox.io/s/cg9c5?file=/src/components/TreeMap.vue:0-2069

    import axios from "axios";

    const baseUri = "WebApi.asmx/api/statisticsService";
    export default {
        name: "networkGraph",
        components: {

        },
        data() {
            return {
                selectedTopic: null,
                loading: true,
                nodes: [],
                links: [],
                categ: [],
                ttl: {
                    SimilarTopics: this.$LanguageProvider.GetResource("SimilarTopics", "Caption", "Ähnliche Themen"),
                }

            };
        },

        created() {
            if (this.topicId > 0) {
                this.loadData(this.topicId)
            }
        },
        computed: {
            categories() {
                return this.$store.state.statisticsStore.networkByKeywordsCategories
            },
            _minSymbolSize() {
                if (this.maxSymbolSize) {
                    return this.minSymbolSize
                }
                else {
                    return 7
                }
            },
            _maxSymbolSize() {
                if (this.maxSymbolSize) {
                    return this.maxSymbolSize
                }
                else {
                    return 50
                }
            },
            _maxLevels() {
                if (this.maxLevels) {
                    return this.maxLevels
                }
                else {
                    return 1
                }
            },
            _maxSatellites() {
                if (this.maxSatellites) {
                    return this.maxSatellites
                }
                else {
                    return 20
                }
            },
        },
        props: ["topicId", "args", "title", "minSymbolSize", "maxSymbolSize", "maxLevels"],
        watch: {
            //nodes: function (value) {
            //    this.series.data = value
            //    this.$refs.chart.refreshOption();
            //},
            //links: function (value) {
            //    this.series.links = value
            //},
            //categories: function (value) {
            //    this.series.categories = value
            //    this.loading = false
            //},
            topicId: function (topicId) {
                this.loadData(topicId)
            },
            args() {
                let uri = window.location.search.substring(1);
                let params = new URLSearchParams(uri);
                return params.get("args");
            },
        },
        methods: {
            openDetail(topicId) {
                this.$emit('opendetail', topicId)
            },
            loadData(topicId) {
                var rouId = 0
                var stgId = 0
                axios
                    .get(baseUri + '/GetNetworkByKeywords?StgId=' + stgId + '&RouId=' + rouId +
                        '&topicId=' + topicId + "&args=" + this.args + "&minSymbolSize=" + this._minSymbolSize +
                        "&maxSymbolSize=" + this._maxSymbolSize + "&maxLevels=" + this._maxLevels +
                        "&maxSatellites=" + this._maxSatellites)
                    .then(res => {

                        if (res.data.success == true) {

                            this.nodes = res.data.data.nodes.filter(m => m.key != topicId)
                            this.links = res.data.data.links
                            this.categ = res.data.data.categories.map(m => { return { name: m }; })
                            this.loading = false

                        }
                        else {
                            alert(res.data.errorMessage)
                        }
                    })
            }
        }
    };
</script>



<style scoped>
    .echBox {
        font-size: 12px;
        gap: 5px;
        margin-top: 10px;
        break-inside: avoid-column;
    }

    .nodes {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: 100%;
        border-bottom: solid 1px rgb( 223, 223, 224);
    }

        .nodes:hover {
            cursor: pointer;
            color: var(--m02-color-1)
        }

    span {
        padding-right: 5px;
    }
</style>